import { apiClient } from "./authService";

export type PaymentProvider = "STRIPE" | "TAP" | "PAYPAL" | "MANUAL";
export type PaymentMethod = "CASH" | "CARD" | "TRANSFER" | "ONLINE";
export type PaymentStatus = "SUCCESS" | "FAILED" | "PENDING";

export interface Payment {
  id: number;
  invoiceId: number;
  amount: number;
  method: PaymentMethod;
  provider: PaymentProvider;
  providerTransactionId?: string;
  status: PaymentStatus;
  createdAt: string;
}

export const getPayments = async (params?: {
  invoiceId?: number;
  provider?: PaymentProvider;
  from?: string;
  to?: string;
}): Promise<Payment[]> => {
  const query = new URLSearchParams({
    ...(params?.invoiceId && { invoiceId: String(params.invoiceId) }),
    ...(params?.provider && { provider: params.provider }),
    ...(params?.from && { from: params.from }),
    ...(params?.to && { to: params.to }),
  }).toString();

  const res = await apiClient.get<Payment[]>(
    `/payments${query ? `?${query}` : ""}`,
  );
  return res.data;
};

export const getPaymentsByInvoice = async (
  invoiceId: number,
): Promise<Payment[]> => {
  const res = await apiClient.get<Payment[]>(
    `/payments?invoiceId=${invoiceId}`,
  );
  return res.data;
};

export const getPaymentsByProvider = async (
  provider: PaymentProvider,
): Promise<Payment[]> => {
  const res = await apiClient.get<Payment[]>(
    `/payments?provider=${provider}`,
  );
  return res.data;
};
